import employeeKeys from "../helper/keys.json";

const buildEmployeeFieldsProjection = () =>
  employeeKeys.reduce(
    (acc, key) => {
      acc[key] = `$$doc.${key}`;
      return acc;
    },
    { id: "$$doc._id" }
  );

export function _getPayrollWithEmployeePipeline(payrollID) {
  return [
    {
      $match: {
        payrollID,
      },
    },
    {
      $lookup: {
        from: "employees",
        localField: "employee.id",
        foreignField: "_id",
        as: "employeeDoc",
      },
    },
    {
      $addFields: {
        id: "$_id",
        employeeId: "$employee.id",
        employee: {
          $let: {
            vars: { doc: { $arrayElemAt: ["$employeeDoc", 0] } },
            in: {
              $cond: {
                if: { $ne: [{ $ifNull: ["$$doc", null] }, null] },
                then: buildEmployeeFieldsProjection(),
                else: { id: "$employee.id" },
              },
            },
          },
        },
      },
    },
    {
      $project: {
        _id: 0,
        employeeDoc: 0,
        createdAt: 0,
        updatedAt: 0,
        acl: 0,
        creator: 0,
        editor: 0,
      },
    },
  ];
}
